import { PLAN_CHECKOUT_BILLING_PATH, PLAN_CHECKOUT_PARAM_KEY } from "constants/subscription/planCheckout";
import { SubscriptionPlanEnum } from "types/subscription/SubscriptionPlanEnum";

/**
 * Path of the billing page that opens a plan's checkout.
 *
 * Output shape: `/muggleTestV0/dashboard/billing?plan=professional`
 */
export const buildPlanCheckoutPath = (planId: SubscriptionPlanEnum): string =>
  `${PLAN_CHECKOUT_BILLING_PATH}?${PLAN_CHECKOUT_PARAM_KEY}=${planId}`;
